<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_LISTAR_CENTRAL_CLIENTE')">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_LISTAR_CENTRAL_CLIENTE')">
            <div class="flex justify-content-center" *ngIf="exibirSpinnerPrincipal">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <div *ngIf="messagemVisivel" class="w-full mb-5">
                <p-messages
                    [(value)]="messages"
                    [enableService]="false"
                    [closable]="true"
                ></p-messages>
            </div>
            <div class="w-full" *ngIf="!exibirSpinnerPrincipal">
                <p-table
                    #dt1
                    [value]="listaPacotes"
                    dataKey="id"
                    [rows]="itensPaginados ? itensPaginados.size : 0"
                    [loading]="loading"
                    [rowHover]="true"
                    [paginator]="true"
                    (onLazyLoad)="onLazyLoad($event)"
                    [totalRecords]="itensPaginados ? itensPaginados.totalElements : 0"
                    [lazy]="true"
                    [showCurrentPageReport]="true"
                    responsiveLayout="stack"
                    styleClass=" p-datatable-sm"
                    currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
                >
                    <ng-template pTemplate="caption">
                        <div class="flex justify-content-between flex-column sm:flex-row">
                            <div class="flex flex-column sm:flex-row w-full">
                                <div class="p-fluid w-full mr-2 sm:w-auto">
                                    <label htmlFor="filtroCompetencia">Status</label>
                                    <p-dropdown
                                        [options]="listaStatusPacote"
                                        emptyFilterMessage="Nenhum registro"
                                        ngModel
                                        #caixas="ngModel"
                                        emptyMessage="Nenhum registro"
                                        [(ngModel)]="statusPacoteSelecionado"
                                        (onChange)="recarregarDados(dt1)"
                                    ></p-dropdown>
                                </div>
                                <div class="p-fluid w-full mr-2 sm:w-auto mt-2 sm:mt-0">
                                    <label for="">Cliente</label>
                                    <p-dropdown
                                        [options]="clientesComPacote"
                                        optionLabel="nome"
                                        placeholder="Selecione"
                                        emptyFilterMessage="Nenhum registro"
                                        name="situacao"
                                        ngModel
                                        #situacao="ngModel"
                                        [(ngModel)]="clienteSelecionado"
                                        (onChange)="recarregarDados(dt1)"
                                    ></p-dropdown>
                                </div>
                            </div>
                            <div class="flex justify-content-end flex-column sm:flex-row">
                                <div class="p-fluid w-full sm:w-auto">
                                    <div class="flex w-full sm:w-auto mt-3 sm:mt-4">
                                        <span class="p-input-icon-left">
                                            <i class="pi pi-search"></i>
                                            <input
                                                pInputText
                                                type="text"
                                                #filter
                                                (input)="buscar($event, dt1)"
                                                placeholder="Buscar"
                                                class="w-full"
                                            />
                                        </span>
                                        <span class="ml-2">
                                            <button
                                                pButton
                                                class="p-button-outlined"
                                                icon="pi pi-filter-slash"
                                                pTooltip="Limpar Filtros"
                                                (click)="limpar(dt1)"
                                            ></button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="numeroOrcamento">
                                Nº
                                <p-sortIcon field="numeroOrcamento"></p-sortIcon>
                            </th>
                            <th pSortableColumn="dataOrcamento">
                                Data
                                <p-sortIcon field="dataOrcamento"></p-sortIcon>
                            </th>
                            <th pSortableColumn="interessado.nome">
                                Cliente
                                <p-sortIcon field="interessado.nome"></p-sortIcon>
                            </th>
                            <th>Tipo</th>
                            <th>Status</th>
                            <th>Ações</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                {{ item.numeroOrcamento }}
                            </td>
                            <td>
                                {{ item.dataOrcamento | date: "dd/MM/yyyy" }}
                            </td>
                            <td>
                                {{ item.interessado.nome }}
                            </td>
                            <td>
                                {{ item.tipo }}
                            </td>
                            <td>
                                <span
                                    class="product-badge bg-gray-600 admihair-text-white"
                                    *ngIf="item.status === 'RESGATADO_CREDITO_CLIENTE'"
                                    pTooltip="Resgate com geração de crédito na conta do Cliente"
                                >
                                    RESGATADO SALDO
                                </span>
                                <span
                                    *ngIf="item.status === 'RESGATADO_PAGO'"
                                    class="product-badge bg-gray-600 admihair-text-white"
                                    pTooltip="Resgatado com pagamento ao Cliente"
                                >
                                    RESGATADO PAGO
                                </span>
                                <span
                                    *ngIf="item.status === 'PAGO'"
                                    class="product-badge bg-blue-600 admihair-text-white"
                                >
                                    {{ item.status }}
                                </span>
                                <span
                                    *ngIf="item.status === 'FINALIZADO'"
                                    class="product-badge bg-green-600 admihair-text-white"
                                >
                                    {{ item.status }}
                                </span>
                                <span
                                    *ngIf="item.status === 'ABERTO'"
                                    class="product-badge bg-teal-600 admihair-text-white"
                                >
                                    {{ item.status }}
                                </span>
                                <span
                                    *ngIf="item.status === 'VENCIDO'"
                                    class="product-badge bg-red-600 admihair-text-white"
                                >
                                    {{ item.status }}
                                </span>
                            </td>
                            <td>
                                <button
                                    pButton
                                    pRipple
                                    pTooltip="Detalhar"
                                    (click)="
                                        redirecionarPagina(
                                            '/apps/central-cliente/pacote/detalhar/' + item.id
                                        )
                                    "
                                    icon="pi pi-eye"
                                    class="p-button-info"
                                ></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7">Nenhum registro encontrado.</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loadingbody">
                        <tr>
                            <td colspan="7">Carregando. Por favor aguarde.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="formgroup" *ngIf="!exibirSpinnerPrincipal">
                <div class="p-fluid p-formgrid grid justify-content-end">
                    <div class="col-12 md:col-4 flex justify-content-end">
                        <button
                            type="button"
                            pButton
                            class="p-button-outlined md:w-9rem mt-5"
                            icon="pi pi-arrow-left"
                            label="Voltar"
                            routerLink="/apps/central-cliente"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
